import { render, staticRenderFns } from "./AutomatedPOConfig.vue?vue&type=template&id=68873ee0&scoped=true"
import script from "./AutomatedPOConfig.vue?vue&type=script&lang=ts"
export * from "./AutomatedPOConfig.vue?vue&type=script&lang=ts"
import style0 from "./AutomatedPOConfig.vue?vue&type=style&index=0&id=68873ee0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68873ee0",
  null
  
)

export default component.exports